// extracted by mini-css-extract-plugin
export default {"uploads":"Pagination_uploads__S2mjv","pagination":"Pagination_pagination__o2ZLc","hide":"Pagination_hide__5w6v0"};